import React, { useState } from "react";
import { motion } from "framer-motion";
import BackgroundAnimated from "../BackgroundAnimated/BackgroundAnimated";
import logo from "../../images/LogoOnlyAnimation.gif";
import logoOre from "../../images/OrevanLogo.png";
import { Formik } from "formik";
import { useNavigate } from "react-router-dom";

function ForgotPassword() {
  const [gradientPosition, setGradientPosition] = useState({ x: 100, y: 100 });
  const [email, setEmail] = useState("");
  const [errorEmail, setErrorEmail] = useState("");
  const navigate = useNavigate();

  const handleMouseMove = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const x = ((e.clientX - rect.left) / rect.width) * 200;
    const y = ((e.clientY - rect.top) / rect.height) * 200;
    setGradientPosition({ x, y });
  };
  const handleReturn = () => {
    navigate("/login");
  };
  const handleSubmit = (e) => {
    e.preventDefault();

    const emailIsValid = email.includes("@") && email.includes(".");

    if (!email) {
      setErrorEmail("Required");
    } else if (!emailIsValid) {
      setErrorEmail("Invalid Email format");
    } else {
      setErrorEmail("");
    }
  };

  return (
    <div className="relative overflow-hidden">
      <div className="h-screen w-screen bg-purpleColorSecond flex justify-center ">
        <motion.div
          initial={{
            opacity: 0,
          }}
          animate={{
            opacity: 1,
          }}
          transition={{
            duration: 2,
            delay: 0.3
          }}
          className="min-h-screen flex items-center  justify-center  bg-darkPurple lg:w-2/5 rounded-3xl relative md:z-10"
        >
          <div className=" text-white p-6  w-full md:max-w-lg lg:max-w-2xl">
            <div className="relative z-10">
              <div className="flex justify-center ml-4 lg:ml-0 md:mb-3">
                <img src={logo} className="w-2/5  md:w-1/3" alt="" />
              </div>
              <p className="text-3xl lg:text-2xl 2xl:text-3xl font-bold text-center md:mb-8 md:mt-4">
                Forgot Password
              </p>
              <div className="my-4">
                <Formik>
                  {() => (
                    <form onSubmit={handleSubmit}>
                      <div>
                        <label className="text-lg font-medium my-3">
                          Email
                        </label>
                        <input
                          onChange={(e) => {
                            setEmail(e.target.value);
                            setErrorEmail("");
                          }}
                          name="email"
                          id="email"
                          className="w-full   rounded-lg p-4 bg-transparentPurple  text-grayColor placeholder-grayColor my-4"
                          type="text"
                          placeholder="Enter Your Email.."
                        />
                        <span className="text-red-600">{errorEmail}</span>
                      </div>

                      <div className="my-4 lg:flex lg:flex-col lg:justify-between md:h-64 2xl:h-96">
                        <div>
                          <motion.button
                            onMouseMove={handleMouseMove}
                            animate={{
                              backgroundPosition: `${gradientPosition.x}% ${gradientPosition.y}%`,
                            }}
                            type="submit"
                            className="bg-gradient-to-r from-greenColor to-greenColorLight text-white py-3 rounded-lg font-bold w-full hover:translate-x-[2px] hover:translate-y-[3px] transition-all duration-75 "
                            style={{
                              backgroundImage:
                                "radial-gradient(circle, #0F3C2B, #56EEB6)",
                              backgroundSize: "300% 300%",
                              transition: "background-position 0.2s ease",
                            }}
                            transition={{
                              duration: 1,
                            }}
                          >
                            <span>Sign In</span>
                          </motion.button>
                          <div className="flex justify-end mt-8">
                            <button
                              onClick={handleReturn}
                              type="button"
                              className="text-greenColorLight underline "
                            >
                              Return Login Page?
                            </button>
                          </div>
                        </div>

                        <div>
                          <img
                            className="w-2/5  md:w-1/3 2xl:w-30 mx-auto mt-4"
                            src={logoOre}
                            alt=""
                          />
                        </div>
                      </div>
                    </form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </motion.div>
        <BackgroundAnimated />
      </div>
    </div>
  );
}

export default ForgotPassword;
